import { createSlice } from "@reduxjs/toolkit";

export const locationSlice = createSlice({
  name: "location",
  initialState: {
    path: ["UKUA"],
    drawerVisible: false,
  },
  reducers: {
    parent: (state) => {
      state.path = state.path.slice(0, state.path.length - 1);
    },
    setPath: (state, {payload}) => {
      state.path = payload;
    },
    toggleDrawer: (state) => {
      state.drawerVisible = !state.drawerVisible;
    },
  },
});

export const selectPath = (state) => state.location.path;
export const selectDrawerVisible = (state) => state.location.drawerVisible;
export const {parent, setPath, toggleDrawer} = locationSlice.actions;
